<template>
  <span :class="tagClass" :style="customStyle">
    <slot></slot>
  </span>
</template>

<script>
/**
 * 自定义标签组件
 * @module CustomTag
 */
export default {
  name: 'CustomTag',
  props: {
    /**
     * 标签颜色，可选primary/success/info/warning/danger或自定义色值
     * @type {String}
     */
    color: {
      type: String,
      default: 'primary'
    },
    /**
     * 标签类型，可选'dark' | 'light' | 'plain'
     * @type {String}
     */
    type: {
      type: String,
      default: 'dark'
    }
  },
  computed: {
    /**
     * 计算标签的class
     * @returns {Array}
     */
    tagClass() {
      return [
        'custom-tag',
        `custom-tag--${this.type}`
      ];
    },
    /**
     * 计算自定义样式
     * @returns {Object}
     */
    customStyle() {
      const colorMap = {
        primary: '#409EFF',
        success: '#67C23A',
        info: '#909399',
        warning: '#E6A23C',
        danger: '#F56C6C'
      };
      const baseColor = colorMap[this.color] || this.color;
      // 判断特殊浅色，字体用黑色
      const isLightBg = ['#FFFFFF', '#ffffff', '#E7E7E7', '#e7e7e7', '#F4F6F8', '#f4f6f8'].includes((baseColor || '').toUpperCase());
      if (this.type === 'dark') {
        return {
          background: baseColor,
          color: isLightBg ? '#000' : '#fff',
          border: 'none'
        };
      } else if (this.type === 'light') {
        return {
          background: baseColor + '22', // 透明度约13%
          color: isLightBg ? '#000' : baseColor,
          border: `1px solid ${baseColor}`
        };
      } else if (this.type === 'plain') {
        return {
          background: '#fff',
          color: isLightBg ? '#000' : baseColor,
          border: `1px solid ${baseColor}`
        };
      }
      return {};
    }
  }
};
</script>

<style scoped lang="less">
.custom-tag {
  display: inline-block;
  font-size: 14px;
  padding: 0 8px;
  height: 28px;
  line-height: 26px;
  border-radius: 4px;
  box-sizing: border-box;
  border: none;
  transition: all 0.2s;
  vertical-align: middle;
  user-select: none;
}
</style>
